<template>
  <div
    :style="containerStyle"
    class="vertical-tabs"
    :class="{
      'vertical-tabs--vertical-text': verticalText,
      'vertical-tabs--horizontal-text': !verticalText,
    }"
  >
    <v-tabs :value="value" :show-arrows="verticalText" :color="color" :slider-color="sliderColor" :style="tabsStyle">
      <v-tab
        v-for="(item, index) in items"
        :to="{ name: routeName, params: { id: item[itemsValue] } }"
        :key="itemsValue ? item[itemsValue] : index"
        >{{ itemsText ? item[itemsText] : item['text'] }}</v-tab
      >
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'vertical-tabs',
  props: {
    color: String,
    height: {
      type: [Number, String],
      default: 300,
    },
    routeName: String,
    items: Array,
    sliderColor: String,
    value: null,
    verticalText: Boolean,
    itemsText: String,
    itemsValue: [Number, String],
  },
  computed: {
    containerStyle() {
      return this.verticalText
        ? {
            height: isNaN(this.height) ? this.height : `${this.height}px`,
          }
        : {
            height: isNaN(this.height) ? this.height : `${this.height}px`,
          };
    },
    tabsStyle() {
      return this.verticalText
        ? {
            width: isNaN(this.height) ? this.height : `${this.height}px`,
          }
        : {
            width: isNaN(this.height) ? this.height : `${this.height}px`,
          };
    },
  },
  watch: {
    //     containerStyle (val) {
    //     console.log(val)
    //   },
    //   tabsStyle (val) {
    //             console.log(val)
    //   },
  },
  methods: {},
};
</script>

<style scoped>
.vertical-tabs {
  overflow: hidden;
}
.vertical-tabs--horizontal-text .v-tabs {
  transform: rotate(90deg);
  transform-origin: 100px 100px;
  height: 200px;
}
.vertical-tabs--horizontal-text .v-tabs >>> .v-tabs__container {
  height: 200px;
}
.vertical-tabs--horizontal-text .v-tabs >>> .v-tabs__div {
  width: 48px;
  height: 200px;
  display: inline-block;
}
.vertical-tabs--horizontal-text .v-tabs >>> .v-tabs__item {
  transform: rotate(-90deg);
  transform-origin: 100px 100px;
  width: 400px;
  height: 48px;
  display: block;
  text-align: left;
  line-height: 36px;
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
}
.vertical-tabs--vertical-text {
  width: 48px;
}
.vertical-tabs--vertical-text .v-tabs {
  transform: rotate(90deg);
  transform-origin: 24px 24px;
}
.vertical-tabs--vertical-text .v-tabs >>> .v-tabs__item {
  transform: rotate(180deg);
}
.vertical-tabs--vertical-text .v-tabs >>> .v-tabs__slider-wrapper {
  top: 0;
  bottom: auto;
}
</style>
